import { createContext } from 'react';

export const TenantContext = createContext({
  tenants: [],
  activeTenant: null,
  loading: true,
  setActiveTenant: () => {},
  refreshTenants: async () => {},
});
